import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase/config';

// Componentes de layout
import Layout from './components/layout/Layout';

// Páginas públicas
import HomePage from './pages/HomePage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DeleteAccountPage from './pages/DeleteAccountPage';

// Páginas protegidas
import LoadsPage from './pages/loads/LoadsPage';

// Componente para rutas protegidas
const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="delete-account" element={<DeleteAccountPage />} />
        
        {/* Rutas protegidas */}
        <Route path="loads" element={
          <ProtectedRoute>
            <LoadsPage />
          </ProtectedRoute>
        } />
        
        {/* Rutas protegidas - temporalmente comentadas hasta implementar las páginas */}
        {/* 
        <Route path="loads/:id" element={
          <ProtectedRoute>
            <LoadDetailPage />
          </ProtectedRoute>
        } />
        <Route path="add-load" element={
          <ProtectedRoute>
            <AddLoadPage />
          </ProtectedRoute>
        } />
        <Route path="profile" element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        } />
        <Route path="profile/:id" element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        } />
        <Route path="chats" element={
          <ProtectedRoute>
            <ChatsPage />
          </ProtectedRoute>
        } />
        <Route path="chat/:id" element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        } />
        <Route path="favorites" element={
          <ProtectedRoute>
            <FavoritesPage />
          </ProtectedRoute>
        } />
        <Route path="my-loads" element={
          <ProtectedRoute>
            <UserLoadsPage />
          </ProtectedRoute>
        } />
        <Route path="assigned-loads" element={
          <ProtectedRoute>
            <AssignedLoadsPage />
          </ProtectedRoute>
        } />
        <Route path="buy-coins" element={
          <ProtectedRoute>
            <BuyPackCoinsPage />
          </ProtectedRoute>
        } />
        */}
      </Route>
    </Routes>
  );
}

export default App;